import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'nominas/solicitudes/periodos-validacion';

/**
 * GET Periodos de Validación
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPeriodosValidacion = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Periodo de Validación por ID
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPeriodoValidacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Periodo de Validación
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPeriodoValidacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Periodo de validación agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Periodo de Validación
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPeriodoValidacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Periodo de validación editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Periodo de Validación
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePeriodoValidacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Periodo de validación eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Periodo de Validación
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarPeriodoValidacion = async (id) => {
  try {
    // Siguiendo la lógica del ejemplo: un patch que actualiza el estado a AUTORIZADO
    const response = await API.patch(`${baseURI}/${id}`, {
      estados_globales: ESTATUS_AUTORIZADO,
    });
    onSuccess(response, 'Periodo de validación autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
